<template>
  <div>
    <button
      type="button"
      style="
        background: rgb(247, 81, 81);
        width: 250px;
        background: linear-gradient(
          180deg,
          #3b5998 80%,
          #ffffff 80%,
          #ffffff 90%,
          #3b5998 90%
        );
      "
      class="btn btn-lg d-flex align-items-center justify-content-center"
      @click="login()"
    >
     <i class="fab fa-facebook-f mr-3"> </i>
      <slot><div style="color: black">Continuar com Facebook</div></slot>
    </button>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import makeToast from '../mixins/makeToast';

export default {
  name: 'FacebookGoogleLogin',
  mixins: [makeToast],
  props: {
    pushToRouteName: {
      type: String,
      default: 'cliente-meus-dados',
    },
  },
  computed: {
    ...mapState({
      dadosUsuario: (state) => state.dadosUsuario,
    }),
    ...mapGetters('config', ['getFacebookClientId']),
    ...mapGetters(['getNotification']),
  },
  created() {
    this.$store.dispatch('startLoader');

    const facebookSignInAPI = document.createElement('script');
    const urlFacebookApi = 'https://connect.facebook.net/pt_BR/sdk.js';
    facebookSignInAPI.setAttribute('src', urlFacebookApi);
    facebookSignInAPI.async = true;
    facebookSignInAPI.setAttribute('crossorigin', 'anonymous');
    document.body.appendChild(facebookSignInAPI);

    this.$store.dispatch('endLoader');
  },
  methods: {
    async onFacebookAuthSuccess(accessToken) {
      const network = {
        provider: 'facebook',
        accessToken,
      };

      this.$store.dispatch('startLoader');
      await this.$store
        .dispatch('login/socialLogin', network)
        .then(() => {
          this.$store.dispatch('endLoader');
          if (this.dadosUsuario !== null) {
            this.makeToast('Sucesso', 'Login realizado com sucecsso');

            this.$emit('closeUserTypeModal');

            setTimeout(() => {
              this.$router.push({ name: this.$props.pushToRouteName });
            }, 1000);
          } else {
            this.$store.dispatch('endLoader');
            this.makeToast('Oops', this.getNotification, 'danger');
          }
        })
        .catch(() => {
          this.$store.dispatch('endLoader');
          this.makeToast(
            'Ooops',
            `Parece que algo deu errado no Login com o ${network.provider}, tente novamente mais tarde`,
            'danger'
          );
        });
    },
    onFacebookAuthFail() {
      this.makeToast(
        'Ooops',
        'Parece que algo deu errado ao se autenticar usando o Facebook, tente novamente mais tarde',
        'danger'
      );
    },
    login() {
      window.FB.init({
        appId: this.getFacebookClientId,
        cookie: true,
        version: 'v8.0',
      });

      FB.login(
        (facebookResponse) => {
          if (facebookResponse.status === 'connected') {
            this.onFacebookAuthSuccess(
              facebookResponse.authResponse.accessToken
            );
          } else {
            this.onFacebookAuthFail();
          }
        },
        { scope: 'email' }
      );
    },
  },
};
</script>

<style scoped>
.btn {
  border: 1.4px solid var(--grey);
  border-radius: 8px;
}

.facebook-icon {
  color: #ffffff;
}
</style>
